import React from 'react';
import { useTranslation } from 'react-i18next';
import AccordionSection from '../components/AccordionSection';
import CallToAction from '../components/CallToAction';
import ServicesDetails from '../components/ServicesDetails';

const Services = () => {
  const { t } = useTranslation(); // plus besoin de spécifier 'PageServices' car t() accède déjà à la structure

  return (
    <>
      {/* Section Services */}
      <div className="bg-gray-50 dark:bg-slate-950 py-10">
        <div className="text-center px-6 lg:px-20 mb-12">
          <h6 className="text-xl font-bold text-blue-600 mb-4">{t('PageServices.servicesSpan')}</h6>
          <h1 className="text-4xl font-bold text-gray-800 dark:text-gray-200 mb-4">
            {t('PageServices.servicesTitle')} <span className="text-blue-600">{t('PageServices.servicesSpan')}</span>
          </h1>
          <p className="text-gray-600 dark:text-gray-400">{t('PageServices.description')}</p>
        </div>

        {/* Grille des services */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 px-10">
          <ServicesDetails
            id="WebDevelopment"
            title={t('PageServices.webDevelopment.title')}
            subtitle={t('PageServices.webDevelopment.subtitle')}
            icon={<img src='images/developpers.png' alt="Web Dev Icon" width={50} />}
            description={t('PageServices.webDevelopment.description')}
            features={[
              'Design Web Personnalisé',
              'Solutions E-commerce',
              'Systèmes CMS',
              'Optimisation Mobile',
            ]}
            image={'/web.png'}
          />
          <ServicesDetails
            id="DigitalMarketing"
            title={t('PageServices.digitalMarketing.title')}
            subtitle={t('PageServices.digitalMarketing.subtitle')}
            icon={<img src='images/marketing1.png' alt="Marketing Icon" width={50} />}
            description={t('PageServices.digitalMarketing.description')}
            features={[
              'SEO',
              'Publicité PPC',
              'Marketing des Réseaux Sociaux',
              'Marketing de Contenu',
            ]}
            image={'/marketing.png'}
          />
          <ServicesDetails
            id="seoServices"
            title={t('PageServices.seoServices.title')}
            subtitle={t('PageServices.seoServices.subtitle')}
            icon={<img src='images/search.png' alt="SEO Icon" width={50} />}
            description={t('PageServices.seoServices.description')}
            features={[
              'SEO Technique',
              'SEO Local',
              'SEO On-Page',
              'SEO Off-Page',
            ]}
            image={'/seo.png'}
          />
          <ServicesDetails
            id="graphicDesign"
            title={t('PageServices.graphicDesign.title')}
            subtitle={t('PageServices.graphicDesign.subtitle')}
            icon={<img src='images/design.png' alt="Design Icon" width={50} />}
            description={t('PageServices.graphicDesign.description')}
            features={[
              'Création de Logo',
              'Design UX/UI',
              'Supports Marketing',
              'Packages de Branding',
            ]}
            image={'/design.png'}
          />
          <ServicesDetails
            id="mobileDevelopment"
            title={t('PageServices.mobileDevelopment.title')}
            subtitle={t('PageServices.mobileDevelopment.subtitle')}
            icon={<img src='images/mobile1.png' alt="Mobile Icon" width={50} />}
            description={t('PageServices.mobileDevelopment.description')}
            features={[
              'Développement d’Apps sur mesure',
              'Solutions iOS et Android',
              'Maintenance et Support',
              'Design d’Interface Mobile',
            ]}
            image={'/mobile.png'}
          />
        </div>
      </div>

      {/* Section Appel à l'action */}
      <CallToAction
        title={t('PageServices.cta.title')}
        description={t('PageServices.cta.description')}
      />

      {/* FAQ */}
      <AccordionSection />
    </>
  );
};

export default Services;
